import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetHeaderTaskPageData = createAsyncThunk(
  "GetHeaderTaskPageData",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/HeaderTaskPage/GetHeaderTaskPageData",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetHeaderTaskPageData");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const HeaderTaskPageData = createSlice({
  name: "HeaderTaskPageData",
  initialState: {
    HeaderTaskPageData: {},
    loadingHeaderTaskPageData: false,
    errorHeaderTaskPageData: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetHeaderTaskPageData.pending, (state, action) => {
        state.loadingHeaderTaskPageData = true;
        state.HeaderTaskPageData = action.payload;
        state.errorHeaderTaskPageData = null;
      })
      .addCase(GetHeaderTaskPageData.fulfilled, (state, action) => {
        state.loadingHeaderTaskPageData = false;
        state.HeaderTaskPageData = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetHeaderTaskPageData.rejected, (state, action) => {
        state.loadingHeaderTaskPageData = false;
        state.errorHeaderTaskPageData = action.payload;
      });
  },
});

export default HeaderTaskPageData.reducer;
